import { render, staticRenderFns } from "./TopTenShareHolders.vue?vue&type=template&id=5c5173c4&scoped=true&"
import script from "./TopTenShareHolders.vue?vue&type=script&lang=js&"
export * from "./TopTenShareHolders.vue?vue&type=script&lang=js&"
import style0 from "./TopTenShareHolders.vue?vue&type=style&index=0&id=5c5173c4&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5173c4",
  null
  
)

export default component.exports